import { combineReducers } from 'redux';

import statusData from './status/reducer';
import consumerData from './consumer/reducer';
import supplyData from './supply/reducer';
import firmwareData from './firmware/reducer';
import statusForLast4HoursData from './statusForLast4Hours/reducer';
import statusForLast75MinsData from './statusForLast75Mins/reducer';

export default combineReducers({
  statusData,
  consumerData,
  supplyData,
  firmwareData,
  statusForLast4HoursData,
  statusForLast75MinsData,
});
